import { Animated, Pressable, Platform } from "react-native";
import { useEffect, useRef, useState } from "react";
import { Text, View } from "@constants/Themed";
import { useDispatch, useSelector } from 'react-redux';
import styles from "@stylesheet";
import Modal from 'react-native-modal';
import LottieView from "@utils/lottieAnimation";
import { useLottieAnim } from '@hooks/lottieHook';
import { DefaultRootState } from '@reduxLocal/persistState';
import React from "react";
import { HIDE_AUTH_MODAL, HIDE_LOADING_MODAL, PENDING_REFRESH, REFRESHED, SHOW_AUTH_MODAL, UPDATED_CALENDAR_ENTRIES } from "@reduxLocal/actions/types";
import { BlurView } from 'expo-blur';
import { useWindowDimensions } from 'react-native';
import * as Animatable from 'react-native-animatable';
import { CountUp } from "use-count-up";
import { themeSelector } from "@reduxLocal/selectors/themeSelector";

const LoadingModal = () => {
  const visibleState = useSelector((state: DefaultRootState) => state.modals.loadingModal);
  const modalContent = useSelector((state: DefaultRootState) => state.modals.loadingModal.content);
  const messageCount = useSelector((state: DefaultRootState) => state.UI.counts?.messageCount);
  const invitationCount = useSelector((state: DefaultRootState) => state.UI.counts?.invitationCount);
  const calendarCount = useSelector((state: DefaultRootState) => state.UI.counts?.calendarCount);
  const [loaded, setLoaded] = useState(false);
  const [waitMessage, setWaitMessage] = useState(false);
  const theme = themeSelector();
  const windowDimensions = useWindowDimensions();
const dispatch = useDispatch();
  const [forcedMessage, setForcedMessage] = useState("");

  useEffect(() => {
    setWaitMessage(false)
    if (!loaded) {
      setLoaded(true)
    }
  }, [])

  useEffect(() => {
    if (!visibleState) return;

    // Allow long-running operations (like AI image generation) to complete
    // Default to 10 minutes (600000ms) to match backend timeout chain
    // Can be overridden via REACT_APP_LOADING_MODAL_TIMEOUT_MS env var
    const loadingTimeout = Number(process.env.REACT_APP_LOADING_MODAL_TIMEOUT_MS || 600000);

    const timeoutId = setTimeout(() => {
      dispatch({ type: HIDE_LOADING_MODAL });
      dispatch({ type: SHOW_AUTH_MODAL, data: { content: "Request timed out", type: 'error' } });
    }, loadingTimeout);

    return () => clearTimeout(timeoutId);
  }, [visibleState, dispatch]);


  return (
    <Modal
      animationIn={'fadeIn'}
      animationOut={'fadeOut'}
      isVisible={visibleState}
      hasBackdrop
      deviceHeight={windowDimensions.height*2}
      deviceWidth={windowDimensions.width*2}
      onModalWillShow={() => dispatch({ type: HIDE_AUTH_MODAL })}
      backdropOpacity={.5}
      style={{ justifyContent: "center", alignSelf: 'center', gap: 50, zIndex: 1000000, opacity: 1 }}
    >
      <Animatable.View transition={'width'} style={[styles.modalContainerAuth, { alignSelf: 'center', flex: 1, width: 350, maxWidth: '100%', backgroundColor: theme ? "white" : "black", maxHeight: '60%', opacity: 1, padding: 0 }]}>
        <View style={{ flexDirection: 'column', flex: 1, padding: 50 }}>
          <LottieView style={{ flex: 1, width: 150, height: 150 }} speed={1} source={require('@assets/animations/spin-leaf-loader.json')} autoPlay loop />
          <Text style={{ textAlign: "center" }}>{modalContent || forcedMessage || "Loading..."}</Text>
        </View>
      </Animatable.View>
      {/* <View style={[styles.centerEverything, { flexDirection: 'row', gap: 30 }]}>
        {renderCounterView({ count: invitationCount, index: 0 })}
        {renderCounterView({ count: messageCount, index: 1 })}
        {renderCounterView({ count: calendarCount, index: 2 })}
      </View> */}
    </Modal>
  );
};

const renderCounterView = ({ count, index }) => {
  if (count >= 0) {
    return (
      <Animatable.View useNativeDriver delay={index * 400} animation={'slideInUp'} style={[styles.centerEverything, { flex: 1, backgroundColor: 'white', width: 80, height: 80, borderRadius: 50 }]}>
        <Text style={styles.headerText}>{count}</Text>
      </Animatable.View>
    );
  }
  return null;
};

export default LoadingModal;